<template>

              <v-card class="text-left ma-3">
                <v-card-title>Sky Farm Nudist Club Video</v-card-title>
                <v-card-text>

                  In the 1930s, a group of pioneering nudist
                  enthusiasts purchased a property in the remote
                  Watchung Mountains of central New Jersey. More than
                  75 years later, they're still there, tucked away in
                  what is now the affluent suburban enclave of
                  Bernards Township.

                  <v-btn text color="primary" @click="callLink(0)">{{links[0].title}}</v-btn>
                </v-card-text>
              </v-card>

</template>

<script>
export default {
    data: () => {
        return {
            links: [
                { title: "Sky Farm - Youtube Video",
                  name:  "NJ.com on Youtube",
                  url: 'https://www.youtube.com/watch?v=FADzlwCLlDw',
                },
            ],
        }
    },
    methods: {
        callLink(i) {
            this.$gtag.event('linkto', { event_label: this.links[i].title });
            window.open(this.links[i].url, '_blank')
        }
    }
}

</script>